// Polyfills
require('unfetch');

const React = require('react');
const Layout = require('./src/components/Layout').default;
const getViewportPosition = require('magic-tricks/lib/getViewportPosition')
	.default;
const routeDuration = require('./src/components/Layout').TRANSITION_DURATION;
const {wrapRootElement} = require('./wrapRootElement');
// const Analytics = require('./src/components/Analytics').initialize;

// Setup analytics
// app.analytics = Analytics({
// 	googleAnalyticsPropertyId: process.env.GATSBY_GOOGLE_ANALYTICS_PROPERTY,
// 	googleLinkerDomains: [
// 		'www.dimshome.com',
// 		'dimshome.com',
// 		'shop.dims.world',
// 		'www.dims.world',
// 		'dims.world',
// 		'localhost:8888',
// 		'dimshome.netlify.app',
// 	],
// });

// Wrap every page with the main layout
exports.wrapPageElement = ({element, props}) => (
	<Layout {...props}>{element}</Layout>
);

// Wrap application with Context
exports.wrapRootElement = wrapRootElement;

// Delay updating scroll
exports.shouldUpdateScroll = ({
	prevRouterProps,
	routerProps,
	getSavedScrollPosition,
}) => {
	const isAccount = routerProps.location.pathname.indexOf('/account') === 0;
	const routeTransition = isAccount ? 0 : routeDuration;

	if (routerProps.location.action === 'PUSH') {
		setTimeout(() => {
			const top = getViewportPosition();
			if (global.innerWidth >= 1000) {
				// Scroll to just below banner on desktop
				if (top >= 50) {
					global.scrollTo(0, 50);
				}
			} else {
				// Scroll to just below banner on mobile
				if (top >= 30) {
					global.scrollTo(0, 30);
				}
			}
		}, routeTransition);
	} else {
		setTimeout(() => {
			global.scrollTo(
				...(getSavedScrollPosition(routerProps.location) || [0, 0]),
			);
		}, routeTransition);
	}

	return false;
};

// Site Credit
console.log(`
Site Credit
===========
Development : https://buena-suerte.studio
`);
